import { TextInputModel } from '@libs/form/models';

export const VoucherInputData: TextInputModel = {
  type: 'text',
  name: 'alias',
  label: 'Gutscheincode',
  attributes: {
    spellcheck: false,
  },
};
